import apiClient from './api';
import { API_CONFIG, MESSAGES } from '../utils/constants';

const userService = {
  // Función de login
  login: async (usuario, password) => {
    try {
      const response = await apiClient.get(`${API_CONFIG.ENDPOINTS.USERS}/login`, {
        params: {
          usuario: usuario,
          pass: password,
          valor:1
        }
      });

      // Verificar si la respuesta fue exitosa
      if (response.data && response.data.success === true && response.data.data) {
        return {
          success: true,
          data: response.data.data,
          message: response.data.message || 'Login exitoso'
        };
      } else {
        return {
          success: false,
          message: response.data?.message || 'Credenciales incorrectas'
        };
      }
    } catch (error) {
      console.error('Login error:', error);
      
      // Manejo específico de errores
      if (error.response) {
        // El servidor respondió con un código de error
        const status = error.response.status;
        const responseData = error.response.data;
        
        switch (status) {
          case 400:
            return {
              success: false,
              message: responseData?.message || 'Datos de login inválidos'
            };
          case 401:
            return {
              success: false,
              message: responseData?.message || 'Usuario o contraseña incorrectos'
            };
          case 404:
            return {
              success: false,
              message: 'Usuario no encontrado'
            };
          case 500:
            return {
              success: false,
              message: MESSAGES.ERROR.SERVER
            };
          default:
            return {
              success: false,
              message: responseData?.message || MESSAGES.ERROR.GENERIC
            };
        }
      } else if (error.request) {
        // La petición se hizo pero no hubo respuesta
        return {
          success: false,
          message: MESSAGES.ERROR.NETWORK
        };
      } else {
        // Error al configurar la petición
        return {
          success: false,
          message: MESSAGES.ERROR.GENERIC
        };
      }
    }
  },

  // Función para obtener todos los usuarios (para tu CRUD existente)
  getAll: async () => {
    try {
      const response = await apiClient.get(API_CONFIG.ENDPOINTS.USERS);
      return {
        success: true,
        data: response.data.data || response.data,
        message: MESSAGES.SUCCESS.LOAD
      };
    } catch (error) {
      console.error('Get users error:', error);
      return {
        success: false,
        message: error.response?.data?.message || MESSAGES.ERROR.GENERIC
      };
    }
  },

  // Función para crear usuario
  create: async (userData) => {
    try {
      const response = await apiClient.post(API_CONFIG.ENDPOINTS.USERS, userData);
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || MESSAGES.SUCCESS.CREATE
      };
    } catch (error) {
      console.error('Create user error:', error);
      return {
        success: false,
        message: error.response?.data?.message || MESSAGES.ERROR.GENERIC
      };
    }
  },

  // Función para actualizar usuario
  update: async (id, userData) => {
    try {
      const response = await apiClient.put(`${API_CONFIG.ENDPOINTS.USERS}/${id}`, userData);
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || MESSAGES.SUCCESS.UPDATE
      };
    } catch (error) {
      console.error('Update user error:', error);
      return {
        success: false,
        message: error.response?.data?.message || MESSAGES.ERROR.GENERIC
      };
    }
  },

  // Función para eliminar usuario
  delete: async (id) => {
    try {
      const response = await apiClient.delete(`${API_CONFIG.ENDPOINTS.USERS}/${id}`);
      return {
        success: true,
        data: response.data.data || response.data,
        message: response.data.message || MESSAGES.SUCCESS.DELETE
      };
    } catch (error) {
      console.error('Delete user error:', error);
      return {
        success: false,
        message: error.response?.data?.message || MESSAGES.ERROR.GENERIC
      };
    }
  },

  // Función para obtener un usuario por ID
  getById: async (id) => {
    try {
      const response = await apiClient.get(`${API_CONFIG.ENDPOINTS.USERS}/${id}`);
      return {
        success: true,
        data: response.data.data || response.data,
        message: MESSAGES.SUCCESS.LOAD
      };
    } catch (error) {
      console.error('Get user error:', error);
      return {
        success: false,
        message: error.response?.data?.message || MESSAGES.ERROR.NOT_FOUND
      };
    }
  }
};

export default userService;